import {Component, OnInit, inject, DOCUMENT, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EventsManager} from '../../events/events.manager';
import {IThemeConfig} from '../../models/theme.entity';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss'],
  standalone: false
})

export class HeroComponent implements OnInit {
  private _eventsManager: EventsManager = inject(EventsManager);
  private _destroyRef: DestroyRef = inject(DestroyRef);
  private _document: Document = inject(DOCUMENT);

  private _bannerDesignType: string = '';
  public bannerImageUrl: string = '';
  public bannerImageMobileUrl: string = '';
  public bannerImageAltText: string = '';

  public get bannerClass(): string {
    return this._bannerDesignType ? `hero--${this._bannerDesignType.toLowerCase()}` : '';
  }

  public get hasBanner(): boolean {
    return !!(this._bannerDesignType && this.bannerImageUrl);
  }

  public ngOnInit(): void {
    const style = getComputedStyle(this._document.documentElement);
    const designType = style.getPropertyValue('--banner-design-type').trim();
    if (designType) {
      this._bannerDesignType = designType;
      const rawImageUrl = style.getPropertyValue('--banner-image-url').trim();
      this.bannerImageUrl = rawImageUrl.replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
      const rawMobileUrl = style.getPropertyValue('--banner-image-mobile-url').trim();
      this.bannerImageMobileUrl = rawMobileUrl.replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
    }

    this._eventsManager.setNewCustTheme
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((config: IThemeConfig) => {
        this._bannerDesignType = config.bannerDesignType || '';
        this.bannerImageUrl = config.bannerImageUrl || '';
        this.bannerImageMobileUrl = config.bannerImageMobileUrl || '';
        this.bannerImageAltText = config.bannerImageAltText || '';
      });
  }
}
